import { constants } from 'ethers';

export const NULL_MOVE = '0x0000000000000000000000000000000000000000000000000000000000000000';

export const NULL_ADDRESS = constants.AddressZero;

export const TOTAL_WINS_TO = 3;
export const REFRESH_INTERVAL_FOR_ROOMS = 30_000; // 30 seconds
export const MAX_ACTIVE_ROOMS_TO_FETCH = 50;
export const MAX_ROOMS_PER_BATCH = 50;
export const DEADLINE_BUFFER_MINUTES = 10 * 60 * 1000; // 10 minutes in milliseconds
export const DEFAULT_Z_ICON_COUNT = 3;
export const DEFAULT_SLEEP_TIMEOUT = 40000; // 40 seconds
export const DEFAULT_ROUND_NUMBER = 1;
export const REGEX_BET = /^-?\d*\.?\d+$/;
export const DEFAULT_BET = '5';
export const GAMES_BATCH_SIZE = 21;
export const FETCH_ROOMS_LIMIT = 100;
export const LANDING_PAGE_URL = 'https://rock-paper-scissors.game';
export const WS_EMOJI_CHAT_STATIC_PART = `wss://chat-room.rockpapescissorsgame.workers.dev/room/`;
export const IS_EXPLORE_GAMES_PAGE =
  typeof window !== 'undefined' && window.location.pathname === '/explore-games';
export const IS_STREAM_GAMES_PAGE =
  typeof window !== 'undefined' && window.location.pathname.startsWith('/stream/');
export const DEFAULT_SIGNATURE_MS = 30_000;
export const DEFAULT_RECEIPT_MS = 60_000;

export const DISCORD_USERNAME_LENGTH = 13;
